import * as firebase from 'firebase';
import {map} from 'lodash';
import firebaseApp from '../firebase';
import { paths } from '../paths';
import { ICheckout } from '../profile/model';
import { setCheckouts, setName } from './actions';

type Reference = firebase.database.Reference;
type DataSnapshot = firebase.database.DataSnapshot;

export function loadProfile() {
  return (dispatch: any, getState: any) => {
    const currentState = getState();
    if (!currentState.profile) {
      return;
    }

    const { uid } = currentState.profile;

    if (uid) {
      const path = paths.database.userProfile(uid);

      const profileRef: Reference = firebaseApp.database().ref(path);
      profileRef
        .once('value')
        .then((snap: DataSnapshot) => {
          if (!snap.exists()) {
            console.error('[loadProfile] user profile does not exist', { uid });
          } else {
            const progfileVal = snap.val();

            if (progfileVal) {
              dispatch(
                setName({
                  name: progfileVal.display_name || '',
                })
              );
            } else {
              console.warn(
                '[loadProfile] WARNING the user does not have a profile.',
                { uid }
              );
            }
          }
        })
        .catch((err: Error) => {
          console.error(
            `[loadProfile] Failed loading profile for UID "${uid}".`,
            err
          );
        });
    }
  };
}

export function loadCheckouts(uidParam?: string) {
  return (dispatch: any, getState: any) => {
    const currentState = getState();
    if (!uidParam && !currentState.profile) {
      return;
    }

    const uid = uidParam ? uidParam : currentState.profile.uid;

    if (uid) {
      const path = paths.database.userCheckouts(uid);
      const checkoutsRef: Reference = firebaseApp.database().ref(path);
      checkoutsRef.once('value').then((snap: DataSnapshot) => {
        if (snap.exists()) {
          const checkouts = map(snap.val(), (co: ICheckout) => co)
          dispatch(setCheckouts(checkouts));
        } else {
          dispatch(setCheckouts([]));
        }
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/profile/services.ts